export {
  linkToParentDashboard,
  linkToParentWhatIsPremium,
  isInParentPlatform
} from "./parent/links";

export { linkToMonitoringPage } from "./parent/routes/monitoring/links";
export { linkToInviteChildren } from "./parent/routes/monitoring/routes/overview/routes/invite-children/links";

export {
  linkToSettings,
  linkToPersonalInformation,
  linkToPasswordUpdate,
  linkToPremiumSettings,
  linkToCancelSubscription,
  linkToTransferPremium,
  linkToChangeAccountType
} from "./parent/routes/settings/links";

export {
  makeLinkToParentWhatIsPremium,
  SUBSCRIPTION_JOURNEY_SOURCES
} from "./parent/routes/what-is-premium/links";
export {
  linkToParentUpgradeSubscription,
  linkToParentUpgradeSubscriptionInfoiOS
} from "./parent/routes/what-is-premium/upgrade/links";

export { linkToAssignmentSummaryRoute } from "./parent/routes/child/routes/assignment/links";
